import React, { useState, useContext, useEffect, useRef } from "react";

import { useParams, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { LoadingButton } from "@mui/lab";
import FormControl from "@mui/material/FormControl";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import GeneralContext from "../GeneralContext/GeneralContext";
import Grid from "@mui/material/Grid2";

import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

import axios from "../../api/axios";
import Alert from "@mui/material/Alert";
import { Divider } from "@mui/material";
import PageBody from "../GeneralComponents/PageBody";
import PageBgBlock from "../GeneralComponents/PageBgBlock";
import PageButtonBlack from "../GeneralComponents/PageButtonBlack";
import PageButtonSimple from '../GeneralComponents/PageButtonSimple';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import InputAddress from "../GeneralComponents/InputAddress";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";

import ModalStandard from "../GeneralComponents/ModalStandard";
import HourglassLoader from "../GeneralComponents/HourglassLoader";
import PanelAdminRepresentantes from "../GeneralComponents/PanelAdminRepresentantes";
import PageError from "../GeneralComponents/PageError";

export default function EstablecimientoEdit() {
  const { setDrawerHidding, userSesion } =
    useContext(GeneralContext);
    const formRef = useRef();
  const [loading, setLoading] = useState(true);
  const [loadingButton, setLoadingButton] = useState(false);
  const [documentVisible, setDocumentVisible] = useState(false);


  const [submitConfirm, setSubmitConfirm] = useState(false);
  const [currentRbd, setCurrentRbd] = useState(0);
  const { id } = useParams();

  const fusRef = useRef();
  const emailRef = useRef();
  const direccionRef = useRef();
  const [error, setError] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const [errorAddress, setErrorAddress] = useState(false);

  const [open, setOpen] = React.useState(false);
  const handleClose = () => setOpen(false);
  const navigate = useNavigate();
  const [modalError, setModalError] = useState(false);
  const [modalContent, setModalContent] = useState("");

  const [errors, setErrors] = useState({ rut_rep_1: false, rut_rep_2: false });
  const [listaRep, setListaRep] = useState([]);

  const [formData, setFormData] = useState({
    rbd: "",
    nombre: "",
    id_zona: "",
    fecha_creacion: "",
    email: "",
    latitud: "",
    longitud: "",
    tipo_establecimiento: "",
    telefono: "",
    direccion: "",
    direccion2: "",
    descripcion: "",
    jornada_a: false,
    jornada_b: false,
    jornada_c: false,
    jornada_d: false,
    option: null,
  });

    const [formDataIntentos, setFormDataIntentos] = useState(null);

  const handleErrorChange = (error) => {
    setErrorAddress(error);
  };

  const validateForm = () => {
    const newErrors = {};
    if (
      formData.telefono.trim() &&
      !/^\d{9}$/.test(formData.telefono) &&
      formData.telefono !== "NULL" &&
      formData.telefono !== ""
    ) {
      newErrors.telefono = "Debe ser un número de teléfono válido de 9 dígitos";
    }

    if (formData.direccion.trim() && formData.direccion.trim().length < 5) {
      newErrors.direccion = "La dirección debe tener al menos 5 caracteres";
    }

    if (
      formData.email &&
      (!formData.email.trim() ||
        !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.email)) &&
      formData.email !== "NULL" &&
      formData.email !== ""
    ) {
      newErrors.email = "E-mail inválido";
    }
    if(Object.keys(newErrors).length > 0){
      if (newErrors["direccion"]){
        direccionRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }else{
        emailRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      
    }

    setErrors(newErrors);
    return newErrors;
  };

  const sendRequeriment = () => {

  }
const updateIntento = (patch) =>
  setFormDataIntentos(prev => ({
    ...prev,
    intento: { ...(prev.intento ?? {}), ...patch },
  }));






  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  function getResumen(rbd_temp) {
    axios
      .getResumenIntentosRBD(rbd_temp)
      .then((response) => {
        const updatedData = response.data;

        setFormDataIntentos((prevFormData) => ({
          ...prevFormData,
          ...updatedData,
        }));
        console.log(formData);
      })
      .catch((error) => {
        console.error("Error en getResumen:", error);

        setError(true);
      });
  }


  function getEes(rbd_temp) {

    getResumen(rbd_temp);
    axios
      .getEesInfo(rbd_temp)
      .then((response) => {
        const updatedData = Object.fromEntries(
          Object.entries(response.data).filter(([key]) => key !== "rbd")
        );

        setFormData((prevFormData) => ({
          ...prevFormData,
          ...updatedData,
          rbd: rbd_temp,
        }));
        setLoading(false);

        setError(false);
        setErrorMsg("");

          getEes2(rbd_temp);
      })
      .catch((error) => {
        console.error("Error en getEes:", error);

        setError(true);
        setLoading(false);
      });
  }

   function getEes2(rbd_temp) {
    axios
      .getRepresentantes(rbd_temp)
      .then((response) => {
        const conRbd = response.data.nombres_representantes.map(item => ({
          ...item,
          rbd: rbd_temp
        }));
        if (formRef.current?.setDatosExternos) {
          formRef.current.setDatosExternos(conRbd);
        }
        setListaRep(conRbd);
        setError(false);
      })
      .catch((error) => {
        console.error("Error al obtener datos del EES:", error);
        setError(true);
      });
  }


async function handleClick(event) {
  event.preventDefault();
  setLoadingButton(true);
  getPanelRepData();

  if (Object.keys(validateForm()).length > 0 || !formRef.current?.esValido()) {
    setLoadingButton(false);
    return;
  }
  if (!submitConfirm) {
    setSubmitConfirm(true);
    setLoadingButton(false);
    return;
  }

  
     try {
       
       
       const fallidos = await formRef.current.enviarFormulario(currentRbd);
       const response = await axios.putEesInfo(formData.rbd, formData);
       if (fallidos.length) {
         setModalError(true);
         const ruts = fallidos.map(r => r.rut).join(', ');
         setModalContent(`No se pudo ingresar datos de algunos usuarios (${ruts})`);
       } else {
         setModalContent(`Datos actualizados`);
         setModalError(false);
       }
       setOpen(true);
     } catch (error) {
       setModalError(true);
     } finally {
       setLoading(false);
       setLoadingButton(false);
       setSubmitConfirm(false);
       fetchData();
     }
}



const handleClickIntentos = async (event) => {
  event.preventDefault();
  if (loadingButton) return;
  setLoadingButton(true);
  setLoading(true);

  try {
    if (!currentRbd) throw new Error("RBD no definido");

    const intentoPayload = {
      direccion_ok: !!formDataIntentos?.intento?.direccion_ok,
      internet_ok: !!formDataIntentos?.intento?.internet_ok,
      direccion_texto: formDataIntentos?.intento?.direccion_texto ?? "",
      creado_por: userSesion?.nombre ?? "",
      validar: false,
    };

    const response = await axios.registrarDireccionRBD(formData.rbd, intentoPayload);

    await fetchData?.();
  } catch (error) {
    console.error(error);
    setModalError(true);
  } finally {
    setLoading(false); 
    setLoadingButton(false);
  }
};  




const fetchData = async () => {
      axios
        .getEesByRut(userSesion.rut)
        .then((response) => {
          const rbdSolicitado = id;
          const rbdEncontrado = response.data.some(item => item.rbd === rbdSolicitado);

          setCurrentRbd(rbdSolicitado);

        if (rbdEncontrado) {
          getEes(rbdSolicitado);
          setDocumentVisible(true);
        } else {
          setLoading(false);  // Si no se encuentra el RBD, se oculta el loading
        }
          
        })
        .catch((error) => {});
    };
  const getPanelRepData = () => {
    const datos = formRef.current?.datos;
  };

  useEffect(() => {
    
    fetchData();

    setDrawerHidding(false);
  }, []);

  return (
    <PageBody>
      
        {loading ? (<PageBgBlock pad="0">
          <HourglassLoader /> </PageBgBlock>
        ) : (
          documentVisible ?  (<>

          <Box sx={{mb: 3}}>
          
          {(formDataIntentos && false) && (<PageBgBlock pad="2rem 9rem">
            
             <Typography
                      variant="h1"
                      color="inherit"
                      noWrap
                      sx={{ flexGrow: 1, textAlign: "center", fontWeight: 700 }}
                    >
                     VERIFICACIÓN DE DIRECCIÓN
                    </Typography>
             <Grid size={12}>
                          <Grid sx={{ width: "100%", marginY: 2 }} size={12}>
                            <Box>
                              <InputAddress
                                error={errorAddress}
                                errorAddress={handleErrorChange}
                                option={formDataIntentos.intento?.direccion_ok ?? false}
                                option2={formDataIntentos.intento?.internet_ok ?? false}
                                direccion={formDataIntentos.intento?.direccion_texto ?? ""}
                                handleAddress={(newValue) => updateIntento({ direccion_texto: newValue })}
                                handleOption={(newValue) => updateIntento({ direccion_ok: newValue })}
                                handleOption2={(newValue) => updateIntento({ internet_ok: newValue })}
                                margin="0"
                              />

                            </Box>
                          </Grid>

                            <Grid sx={{ width: "100%", mt: 4 }} size={12}>
                           <Box mt={2} display="flex" justifyContent="center">
                      <PageButtonBlack
                        width="20rem"
                        disabled={ loadingButton }
                        onClick={handleClickIntentos}
                        startIcon={<AddCircleOutlineIcon />}
                        sx={{ borderRadius: 0 }}
                                  loading={loading}
                      >
                        Guardar actualización
                      </PageButtonBlack>
            </Box>
                          </Grid>

                        </Grid>



            </PageBgBlock>) }
            </Box>
            <PageBgBlock pad="2rem 9rem">
              <Stack sx={{ background: "#FFFFFF", borderRadius: "0.5rem" }}>
                <Box ref={fusRef}>
                  <Stack alignItems="left" justifyContent="center" spacing={2}>
                    <Typography
                      variant="h1"
                      color="inherit"
                      noWrap
                      sx={{ flexGrow: 1, textAlign: "center", fontWeight: 700 }}
                    >
                      FICHA DEL EES
                    </Typography>

                    <Box
                      justifyContent="center"
                      sx={{
                        maxWidth: "100%",
                        margin: "0 auto",
                        display: "flex",
                      }}
                    >
                      <Typography
                        variant="body"
                        align="center"
                        sx={{ marginBottom: "2rem", maxWidth: "45rem" }}
                      >
                        Para <b>modificar</b> los datos actuales del
                        establecimiento cambie o complete los campos a editar,
                        cuide que la información esté correcta antes de
                        modificar.
                      </Typography>
                    </Box>

                    <form onSubmit={handleClick} id="parque_update">
                      <Grid container spacing={2}>
                        <Grid size={6}>
                          <Box>
                            <FormControl sx={{ minWidth: "100%" }}>
                              <TextField
                                disabled
                                id="outlined-required"
                                label="RBD"
                                size="small"
                                sx={{ width: "100%" }}
                                value={formData.rbd}
                              />
                            </FormControl>
                          </Box>
                        </Grid>

                        <Grid size={6}>
                          <FormControl sx={{ width: "100%" }} size="small">
                            <TextField
                              disabled
                              id="outlined-required"
                              label="Nombre"
                              name="nombre"
                              size="small"
                              sx={{ width: "100%" }}
                              value={formData.nombre}
                              onChange={handleInputChange}
                            />
                          </FormControl>
                        </Grid>
                        <Grid size={12}>
                          <FormControl sx={{ width: "100%" }} size="small">
                            <TextField
                              disabled
                              id="outlined-required"
                              label="Dirección"
                              size="small"
                              name="direccion"
                              sx={{ width: "100%" }}
                              value={formData.direccion}
                              error={!!errors.direccion}
                              helperText={errors.direccion}
                              onChange={handleInputChange}
                            />
                          </FormControl>
                        </Grid>



                        <Grid size={12} ref={direccionRef}>
                          <FormControl sx={{ width: "100%" }} size="small">
                            <TextField
                              disabled
                              id="outlined-required"
                              label="Dirección"
                              size="small"
                              name="direccion"
                              sx={{ width: "100%" }}
                              value={formData.direccion}
                              helperText={errors.direccion}
                              onChange={handleInputChange}
                            />
                          </FormControl>
                        </Grid>

                        <Grid size={4}>
                          <FormControl fullWidth variant="outlined">
                            <TextField
                              disabled
                              name="latitud"
                              label="Latitud"
                              size="small"
                              value={formData.latitud}
                            />
                          </FormControl>
                        </Grid>
                        <Grid size={4}>
                          <FormControl fullWidth variant="outlined">
                            <TextField
                              disabled
                              name="longitud"
                              label="Longitud"
                              size="small"
                              value={formData.longitud}
                            />
                          </FormControl>
                        </Grid>

                        <Grid size={4}>
                          <FormControl sx={{ width: "100%" }} size="small">
                            <TextField
                              disabled
                              id="id_zona"
                              label="ID Zona"
                              size="small"
                              sx={{ width: "100%" }}
                              value={formData.id_zona}
                            />
                          </FormControl>
                        </Grid>

                        <Grid size={6}>
                          <FormControl fullWidth variant="outlined">
                            <TextField
                              name="telefono"
                              label="Teléfono"
                              size="small"
                              value={formData.telefono}
                              onChange={handleInputChange}
                              error={!!errors.telefono}
                              helperText={errors.telefono}
                            />
                          </FormControl>
                        </Grid>
                        <Grid size={6} ref={emailRef}>
                          <FormControl fullWidth variant="outlined" >
                            <TextField
                              name="email"
                              label="Email de establecimiento"
                              size="small"
                              value={formData.email}
                              onChange={handleInputChange}
                              error={!!errors.email}
                              helperText={errors.email}
                            />
                          </FormControl>
                        </Grid>

                        <Grid size={6}>
                          <FormControl sx={{ width: "100%" }} size="small">
                            <TextField
                              disabled
                              name="tipo_establecimiento"
                              label="Tipo de establecimiento"
                              size="small"
                              value={formData.tipo_establecimiento}
                            />
                          </FormControl>
                        </Grid>
                        <Grid size={6}>
                          <FormControl fullWidth variant="outlined">
                            <TextField
                              disabled
                              name="fecha_creacion"
                              label="Fecha de ingreso"
                              size="small"
                              value={formData.fecha_creacion}
                            />
                          </FormControl>
                        </Grid>



                        <Grid size={4} sx={{ paddingTop: 1 }}>
                          <Typography variant="body">
                            Tipo de jornada:
                          </Typography>
                        </Grid>

                        <Grid size={8}>
                      <Grid container spacing={2} columns={6}>
                        <Grid size={2}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={formData.jornada_a}
                                disabled
                                name="jornada_a"
                              />
                            }
                            label="8:00 a 19:45 (A)"
                          />
                        </Grid>
                        <Grid size={2}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={formData.jornada_b}
                                disabled
                                name="jornada_b"
                              />
                            }
                            label="8:00 a 15:45 (B)"
                          />
                        </Grid>
                        <Grid size={2}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={formData.jornada_c}
                                disabled
                                name="jornada_c"
                              />
                            }
                            label="8:00 a 17:45 (C)"
                          />
                        </Grid>
                        <Grid size={2}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={formData.jornada_d}
                                disabled
                                name="jornada_d"
                              />
                            }
                            label="8:00 a 23:15 (D)"
                          />
                        </Grid>
                        <Grid size={2}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={formData.jornada_e}
                                disabled
                                name="jornada_e"
                              />
                            }
                            label="Ninguno (E)"
                          />
                        </Grid>
                      </Grid>

                      </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid size={12}>
                          <Divider
                            sx={{ marginTop: 4, marginBottom: 2 }}
                          ></Divider>
                        </Grid>

                        <PanelAdminRepresentantes ref={formRef} lista_rep={listaRep} rutUsuario={userSesion.rut} />

 {submitConfirm ? (
                          <Grid
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            size={12}
                            sx={{ paddingY: "2rem" }}
                          >
                            <Alert
                              icon={false}
                              variant="filled"
                              severity="warning"
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                "& .MuiAlert-message": {
                                  textAlign: "center",
                                  width: "inherit",
                                },
                              }}
                            >
                              <Typography
                                variant="body"
                                color="inherit"
                                sx={{ textAlign: "center" }}
                              >
                                Atención: Revise con atención los datos proporcionados en la modificación para evitar procesos erroneos. Al presionar ‘Modificar establecimiento’ se hará el cambio en nustras bases de datos, si no está seguro salga de la edición sin modificar.
                              </Typography>
                            </Alert>
                          </Grid>
                        ) : (
                          ""
                        )}


                                            <Grid size={12}>
                      <Box mt={2} display="flex" justifyContent="center">
              <PageButtonSimple
                    width="20rem"
                    pad="12px 16px"
                    onClick={() => formRef.current?.agregarRepresentante?.()}
                    disabled={!!formRef.current?.disableActions}
                    startIcon={<AddCircleOutlineIcon />}
                    sx={{ borderRadius: 0 }}
                  >
                Agregar Representante del EES
              </PageButtonSimple>

              <PageButtonBlack
                width="20rem"
                disabled={ loadingButton }
                form="parque_update"
                startIcon={<AddCircleOutlineIcon />}
                sx={{ borderRadius: 0 }}
                          loading={loading}
              >
                Guardar actualización
              </PageButtonBlack>
            </Box>
             </Grid>

<Grid size={12}>
      </Grid>



                       
                      </Grid>

                  
                    </form>

                    
                  </Stack>
                </Box>
              </Stack>
          
      </PageBgBlock></>) : <PageError>
                No tiene acceso a esta RBD.
              </PageError> 
        )}
      <ModalStandard
        open={open}
        error={modalError}
        title={modalContent}
        btnText="Ir a Inicio"
        onClick={() => navigate("/home")}
        onClose={handleClose}
      ></ModalStandard>
    </PageBody>
  );
}

